/*!
 * devextreme-angular
 * Version: 20.2.13
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

export * from './component';
export * from './events-strategy';
export * from './integration';
export * from './iterable-differ-helper';
export * from './nested-option';
export * from './template-host';
export * from './template';
export * from './transfer-state';
export * from './utils';
export * from './watcher-helper';
